import { AlertSrv, ListBaseController } from "../components/fx";
import { ConfirmAction } from "../components/fx/confirm-action/ConfirmAction";
import * as userService from "../services/UserService";

const pageConfig: any = {
    pageTitle: 'Users',
    sections: [
        {
            type: "filter",
            layout: 4,
            controls: [
                { label: 'Display Name / email', model: 'displayName', type: 'text' },
                { label: 'Role', model: 'roleCode', type: 'combo', default: true, defaultValue: "-1", valueField: "code", displayField: "text", lookupKey: "Roles" },
                { label: 'Is Disabled', model: 'isDisabled', type: 'checkbox', defaultValue: false }
            ]
        },
        {
            type: "listview",
            listViewConfig: {
                canShowHeader: true,
                pagerConfig: {
                    pageSize: 25
                },
                sorterConfig: {
                    sortable: true,
                    sortInfo: {
                        name: "created_at",
                        direction: "desc"
                    }
                },
                mode: 'normal',
                fieldDefs: [
                    { field: 'displayName', title: 'Display Name', type: 'label', size: 2, sort: true },
                    { field: 'email', title: 'E-Mail', type: 'label', size: 3, sort: true },
                    { field: 'roleName', title: 'Role', type: 'label', size: 2, sort: true },
                    { field: 'disableValue', title: 'Disabled', type: 'label', size: 1, sort: true },
                    { field: 'registrationStatus', title: 'Registration Status', type: 'label', size: 2, sort: true },
                    { field: 'actions', title: 'Actions', type: 'label', size: 2 }
                ],
                actions: [
                    { name: 'resendinvite' },
                    { name: 'edit', displayText: 'Edit' },
                    { name: 'delete', displayText: 'Delete', placeholder: 'displayName' },
                ]
            }
        }
    ],
    actionBar: {
        controls: [
            { name: "add", displayText: 'Invite' }
        ]
    }
}

const confirmResendInvite = (set: any, get: any) => {
    return async (item: any) => {
        let msg: any = 'Do you want to resend the invite to ' + item.email + ' ?'
        ConfirmAction({
            message: msg,
            okAction: confirmResendInviteEvent(set, get),
            item: item
        })
    }
}

const confirmResendInviteEvent = (set: any, get: any) => {
    return async (item: any = {}) => {
        let inputData = {
            email: item.email,
            displayName: item.displayName,
            practiceId: item.practiceId
        }
        await userService.resendInvite(inputData)
        AlertSrv.showSuccessMsg();
    }
}

const customActions: any = {
    confirmResendInvite: confirmResendInvite
}

const listBaseController = ListBaseController({
    pageConfig: pageConfig,
    actions: {
        getItems: userService.getUsers,
        deleteItem: userService.deleteUser,
        getLookups: userService.getLookups
    },
    customActions
}
);

export const useUserListStore = listBaseController.getStore();